export default __webpack_public_path__ + "static/media/Send.f270e523.svg";